var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyGmx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.001,
    height: 57.823,
    viewBox: "0 0 88.001 57.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(-824.999 -143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ic_base",
    width: 88,
    height: 56,
    transform: "translate(825 143)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M55.155,34.774A27.99,27.99,0,1,1,34.766.839,27.992,27.992,0,0,1,55.155,34.774h0Z",
    transform: "translate(825 142.999)",
    fill: "#303fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M42.356,26.7A21.495,21.495,0,1,1,26.7.644,21.5,21.5,0,0,1,42.356,26.7h0Z",
    transform: "translate(831.496 149.497)",
    fill: "#fff",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M47.282,29.81A23.995,23.995,0,1,1,29.8.719,24,24,0,0,1,47.282,29.81h0Z",
    transform: "translate(851 152.816)",
    fill: "#02cecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_44",
    "data-name": "Intersection 44",
    d: "M10656.72,1074.889a24,24,0,0,1,22.567-18.187,27.967,27.967,0,0,1,5.869,24.947v0a27.969,27.969,0,0,1-17.635,19.552A24,24,0,0,1,10656.72,1074.889Z",
    transform: "translate(-9805 -903.875)",
    fill: "#4fcffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M35.331,22.275A17.93,17.93,0,1,1,22.27.537,17.931,17.931,0,0,1,35.331,22.275h0Z",
    transform: "translate(857.066 158.883)",
    fill: "#fff",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M36.455,22.985A18.5,18.5,0,1,1,22.979.555a18.5,18.5,0,0,1,13.477,22.43h0Z",
    transform: "translate(875.992 163.808)",
    fill: "#50d0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_45",
    "data-name": "Intersection 45",
    d: "M10661.546,1071.9a18.507,18.507,0,0,1,18.622-14.019,23.929,23.929,0,0,1,3.112,18.8h0a23.95,23.95,0,0,1-12.871,15.815A18.509,18.509,0,0,1,10661.546,1071.9Z",
    transform: "translate(-9785 -894.059)",
    fill: "#51f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M26.6,16.771A13.5,13.5,0,1,1,16.767.4,13.5,13.5,0,0,1,26.6,16.771h0Z",
    transform: "translate(880.994 168.811)",
    fill: "#fff",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_GMX",
    transform: "translate(880.993 171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M552.336,715.348,539.022,696l-13.356,19.349h18.607l-5.251-7.385-2.605,3.837h-2.77l5.375-7.715,7.773,11.263Z",
    transform: "translate(-525.667 -696)",
    fill: "rgba(255,255,255,0.99)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyGmx);
export default __webpack_public_path__ + "static/media/buy_gmx.618eb538e0dac8faccd7e0f192534da3.svg";
export { ForwardRef as ReactComponent };